import { render, staticRenderFns } from "./FarmUnitContainer.vue?vue&type=template&id=588f4047&scoped=true&"
import script from "./FarmUnitContainer.vue?vue&type=script&lang=ts&"
export * from "./FarmUnitContainer.vue?vue&type=script&lang=ts&"
import style0 from "./FarmUnitContainer.vue?vue&type=style&index=0&id=588f4047&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588f4047",
  null
  
)

export default component.exports